import React from 'react'
import { withTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { UPLOAD_STATUS } from '../utils/constants.js'

import {
    ASSET_MANAGER__ADD_UPLOAD_MEDIA,
    ASSET_MANAGER__ADD_UPLOAD_MEDIA_INFO,
} from '../../../../store/actions/asset_manager'

import './UploadMedia.scss'

const SUPPORT_TYPES = new Set(['image/jpeg', 'image/png', 'image/gif'])
const MAX_FILE_SIZE = 12_582_912

const UploadMedia = ({ className = '', variant, size, children, t }) => {
    const dispatch = useDispatch()

    const onChange = async ev => {
        for (const file of ev.target.files) {
            if (file.size >= MAX_FILE_SIZE) {
                dispatch(
                    ASSET_MANAGER__ADD_UPLOAD_MEDIA_INFO({
                        total: file.size,
                        name: file.name,
                        status: UPLOAD_STATUS.error,
                        message: t('File size is too large'),
                    }),
                )
                continue
            }
            if (SUPPORT_TYPES.has(file.type)) {
                dispatch(ASSET_MANAGER__ADD_UPLOAD_MEDIA(file))
            }
        }
    }

    return (
        <>
            <input
                className="upload-media"
                type="file"
                id="upload-media"
                onChange={onChange}
                multiple
                accept="image/jpeg,image/png,image/gif"
            />
            <label className={`label ${className}`} htmlFor="upload-media" data-variant={variant} data-size={size}>
                {children}
            </label>
        </>
    )
}

export default withTranslation('translations')(UploadMedia)
